module.exports = __webpack_public_path__ + "static/media/tri_sector1.28de9900.svg";